import { render, staticRenderFns } from "./ToggleFavoriteRequests.vue?vue&type=template&id=e2eab4f2&scoped=true"
import script from "./ToggleFavoriteRequests.vue?vue&type=script&lang=ts"
export * from "./ToggleFavoriteRequests.vue?vue&type=script&lang=ts"
import style0 from "./ToggleFavoriteRequests.vue?vue&type=style&index=0&id=e2eab4f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2eab4f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2eab4f2')) {
      api.createRecord('e2eab4f2', component.options)
    } else {
      api.reload('e2eab4f2', component.options)
    }
    module.hot.accept("./ToggleFavoriteRequests.vue?vue&type=template&id=e2eab4f2&scoped=true", function () {
      api.rerender('e2eab4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/favorite/ToggleFavoriteRequests.vue"
export default component.exports